/* eslint-disable no-undef */
import "bootstrap";
import "floating-form-labels";
import "@fancyapps/fancybox";
import "jquery-touchswipe";

/** floating label **/
function initFloating() {
  $(".input-label, .form-group").floatingFormLabels({
    label: "label",
    floatedClass: "is-floating"
  });
}

initFloating();

// make Flickity a jQuery plugin
Flickity.setJQuery($);
jQueryBridget("flickity", Flickity, $);

/** is touch **/
function is_touch_device() {
  var prefixes = " -webkit- -moz- -o- -ms- ".split(" ");
  var mq = function(query) {
    return window.matchMedia(query).matches;
  };
  if (
    "ontouchstart" in window ||
    (window.DocumentTouch && document instanceof DocumentTouch)
  ) {
    return true;
  }
  var query = ["(", prefixes.join("touch-enabled),("), "heartz", ")"].join("");
  return mq(query);
}

if (is_touch_device()) {
  $("body").addClass("isTouch");
} else {
  $("body").addClass("noTouch");
}
// eslint-disable-next-line no-unused-vars
var touchMove = false;
$(document).on("touchmove", function() {
  touchMove = true;
});
$(document).on("touchstart", function() {
  touchMove = false;
});

/** transitions after load **/
$(window).on("load", function() {
  $("body").removeClass("preload");
});

/** lazyload **/
const observer = lozad(".lozad", {
  loaded: function(el) {
    el.classList.add("lozad-loaded");
  }
});
observer.observe();

/** anchor animation **/
$("a[href*=\\#]").on("click", function(event) {
  if ($(this.hash).length) {
    event.preventDefault();
    $("html,body").animate({ scrollTop: $(this.hash).offset().top - 70 }, 1000);
  } else {
    return true;
  }
});

/** sticky nav **/
function navScroll() {
  if ($(document).scrollTop() > 120) {
    $(".nav").addClass("scroll");
  } else {
    $(".nav").removeClass("scroll");
  }
}

navScroll();
$(window).scroll(function() {
  navScroll();
});
$(window).resize(function() {
  navScroll();
});

/** nav **/
function navOpen() {
  $(".hamburger").addClass("is-active");
  $(".nav__main").addClass("is-open");
}

function navClose() {
  $(".hamburger").removeClass("is-active");
  $(".nav__main").removeClass("is-open");
}

$(document).on("click", ".js-open-nav", function() {
  if ($(this).hasClass("is-active")) {
    navClose();
  } else {
    navOpen();
  }

  return false;
});

/** textarea **/
function formTextarea() {
  $(".contact-form__textarea textarea").on("input", function() {
    $(this).css("height", this.scrollHeight + "px");
  });
}

/** spustit funkce po stažení fontu **/
WebFont.load({
  google: {
    families: ["Montserrat", "Source Sans Pro"]
  },
  active: function() {
    formTextarea();
  }
});

$("[data-fancybox]").fancybox({
  buttons: ["slideShow", "fullScreen", "download", "thumbs", "close"]
});

// eslint-disable-next-line no-unused-vars

$(document).ready(function() {
  $(".table-row")
    .slice(0, 3)
    .show();
  if ($(".table-row:hidden").length != 0) {
    $("#loadMore").show();
  }
  $("#loadMore").on("click", function(e) {
    e.preventDefault();
    $(".table-row:hidden").slideDown();
    if ($(".table-row:hidden").length == 0) {
      $("#loadMore").fadeOut("slow");
    }
  });
});
